import React, { useEffect } from "react"
import classNames from "classnames"

import { Tooltip } from "react-tippy"
import data from "./data"
import CopyIcon from "../../../assets/_V2/svg/CopyIcon"
import { registrationSuccessEvent } from "../../../gtm-events"

import { concealPhone } from "../../../utils"

import styles from "./styles.module.scss"

function RegistrationSuccess(props) {
	const cloudUrl = `https://${props.createdCloudData.cloudName}`

	useEffect(() => {
		try {
			registrationSuccessEvent()
		} catch {
			console.log("gtm не найден")
		}
	}, [])

	const copyAddress = () => {
		navigator.clipboard.writeText(cloudUrl)
	}

	return (
		<section className={styles.registrationSuccess}>
			{data.img}

			<div className={styles.registrationSuccess__content}>
				<h3 className={styles.registrationSuccess__title}>{data.title}</h3>

				<p className={styles.registrationSuccess__description}>
					{`${data.description} ${concealPhone(props.phone)}`}
				</p>

				<div className={styles.registrationSuccess__actions}>
					<label htmlFor="cloudAddress" className={classNames(styles.input)}>
						<div className={styles.inputContainer}>
							<div className={styles.inputWithTitle}>
								<p className={styles.inputTitle}>{data.cloudAddressLabel}</p>
								<input
									className={styles.inputField}
									type="text"
									id="cloudAddress"
									readOnly
									value={cloudUrl}
								/>
							</div>
							<Tooltip
								title="Скопировано"
								duration={1000}
								hideDuration={1000}
								hideDelay={4000}
								arrow
								size="small"
								position="bottom"
								trigger="click"
							>
								<div className={styles.icon} onClick={copyAddress}>
									<CopyIcon />
								</div>
							</Tooltip>
						</div>
					</label>

					<a
						href={cloudUrl}
						target="_blank"
						className={styles.registrationSuccess__btn}
						rel="noreferrer"
					>
						{data.linkText}
					</a>
				</div>
			</div>
		</section>
	)
}

export default RegistrationSuccess
